export * from './font-picker.component';
export * from './font-picker.directive';
export * from './font-picker.module';
export * from './font-picker.service';
export * from './interfaces';
export * from './pipes';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
